import { type } from '@/utils/type'


export const MESUREUNITE_REQUEST = type('MESUREUNITE_REQUEST')
export const MESUREUNITE_SUCCESS = type('MESUREUNITE_SUCCESS')
export const MESUREUNITE_ERROR = type('MESUREUNITE_ERROR')

export const MESUREUNITE_ENSURE_LIST = type('MESUREUNITE_ENSURE_LIST')

export const MESUREUNITE_SELECT_DETAIL_REQUEST = type('MESUREUNITE_SELECT_DETAIL_REQUEST')
export const MESUREUNITE_SELECT_DETAIL_SUCCESS = type('MESUREUNITE_SELECT_DETAIL_SUCCESS')
export const MESUREUNITE_SELECT_DETAIL_ERROR = type('MESUREUNITE_SELECT_DETAIL_ERROR')
export const MESUREUNITE_SELECT_DETAIL = type('MESUREUNITE_SELECT_DETAIL')

export const MESUREUNITE_SAVE_REQUEST = type('MESUREUNITE_SAVE_REQUEST')
export const MESUREUNITE_SAVE_SUCCESS = type('MESUREUNITE_SAVE_SUCCESS')
export const MESUREUNITE_SAVE_ERROR = type('MESUREUNITE_SAVE_ERROR')

export const MESUREUNITE_UPDATE_MODIFIED_ADM = type('MESUREUNITE_UPDATE_MODIFIED_ADM')
export const MESUREUNITE_CANCEL_MODIFIED_ADM = type('MESUREUNITE_CANCEL_MODIFIED_ADM')

export const MESUREUNITE_UPDATE_FILTER_ADM = type('MESUREUNITE_UPDATE_FILTER_ADM')